"use client";

import { create } from "zustand";

interface LoadingState {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean | undefined) => void;
}

/**
 * Global loading state store
 * Used to manage application-wide loading states
 */
export const useLoadingStore = create<LoadingState>((set) => ({
  isLoading: false,
  setIsLoading: (isLoading: boolean | undefined) => set({ isLoading: isLoading ?? false }),
}));
